import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { LorenRoleComponent } from "./loren-role/loren-role.component";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { TranslocoModule } from "@jsverse/transloco";

import { LorenSharedDirectivesModule } from "../../shared/directives/loren-shared-directives.module";
import { LorenPageContentComponent } from "../../shared/modules/loren-page-content/loren-page-content.component";

const routes: Routes = [
  {
    path: "",
    component: LorenRoleComponent,
  },
];

@NgModule({
  declarations: [LorenRoleComponent],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes),
    MatListModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinner,
    MatIconModule,
    TranslocoModule,
    LorenSharedDirectivesModule,
    LorenPageContentComponent,
  ],
})
export class LorenRolesModule {}
